export type ProfileType = 'hpg' | 'cd' | 'n17' | 'unkown';

export interface Profile {
  id: ProfileType;
  label: string;
  icon: string;
  color: string;
}

export const PROFILES: Profile[] = [
  { id: 'hpg', label: 'HPC', icon: 'workspace_premium', color: '#1976d2' },
  { id: 'cd', label: 'Senior Executives', icon: 'business_center', color: '#7b1fa2' },
  { id: 'n17', label: 'NP17/18', icon: 'groups', color: '#388e3c' },
  { id: 'unkown', label: '-', icon: '', color: '#388e3c' },
];

export const DEFAULT_PROFILE: ProfileType = 'unkown';
export const STORAGE_KEY = 'user_profile';
